//NOTE autogenerated by export script
import { AdminFailedNotificationsService as AdminFailedNotificationsServiceType } from './adminFailedNotifications.service'
export const AdminFailedNotifications: typeof AdminFailedNotificationsServiceType = {} as any
import { AdminOrderItemConfigurationsService as AdminOrderItemConfigurationsServiceType } from './adminOrderItemConfigurations.service'
export const AdminOrderItemConfigurations: typeof AdminOrderItemConfigurationsServiceType = {} as any
import { AdminOrdersService as AdminOrdersServiceType } from './adminOrders.service'
export const AdminOrders: typeof AdminOrdersServiceType = {} as any
import { BffAdminOofWebService as BffAdminOofWebServiceType } from './bffAdminOofWeb.service'
export const BffAdminOofWeb: typeof BffAdminOofWebServiceType = {} as any
import { BffOofWebService as BffOofWebServiceType } from './bffOofWeb.service'
export const BffOofWeb: typeof BffOofWebServiceType = {} as any
import { ConfigTemplatesAdminAPIService as ConfigTemplatesAdminAPIServiceType } from './configTemplatesAdminAPI.service'
export const ConfigTemplatesAdmin: typeof ConfigTemplatesAdminAPIServiceType = {} as any
import { ConfigTemplatesCustomerAPIService as ConfigTemplatesCustomerAPIServiceType } from './configTemplatesCustomerAPI.service'
export const ConfigTemplatesCustomer: typeof ConfigTemplatesCustomerAPIServiceType = {} as any
import { MeUserService as MeUserServiceType } from './meUser.service'
export const MeUser: typeof MeUserServiceType = {} as any
import { OrderDeviceAllocationAdminAPIService as OrderDeviceAllocationAdminAPIServiceType } from './orderDeviceAllocationAdminAPI.service'
export const OrderDeviceAllocationAdmin: typeof OrderDeviceAllocationAdminAPIServiceType = {} as any
import { OrderItemConfigurationsService as OrderItemConfigurationsServiceType } from './orderItemConfigurations.service'
export const OrderItemConfigurations: typeof OrderItemConfigurationsServiceType = {} as any
import { OrderItemDevicesService as OrderItemDevicesServiceType } from './orderItemDevices.service'
export const OrderItemDevices: typeof OrderItemDevicesServiceType = {} as any
import { OrderItemsService as OrderItemsServiceType } from './orderItems.service'
export const OrderItems: typeof OrderItemsServiceType = {} as any
import { OrdersService as OrdersServiceType } from './orders.service'
export const Orders: typeof OrdersServiceType = {} as any
import { RmaAdminService as RmaAdminServiceType } from './rmaAdmin.service'
export const RmaAdmin: typeof RmaAdminServiceType = {} as any
import { RmaCustomerService as RmaCustomerServiceType } from './rmaCustomer.service'
export const RmaCustomer: typeof RmaCustomerServiceType = {} as any
import { SystemControllerService as SystemControllerServiceType } from './systemController.service'
export const System: typeof SystemControllerServiceType = {} as any
import { UsersService as UsersServiceType } from './users.service'
export const Users: typeof UsersServiceType = {} as any
export {BASE_PATH} from '../variables'
import { ApiModule as ApiModuleType } from '../api.module'
export const ApiModule: typeof ApiModuleType = {} as any
import { AllServices as AllServicesType } from './allService'
export const All: typeof AllServicesType = {} as any